import styled from 'styled-components';
import useAxios from 'axios-hooks';

import { useEffect, useRef, useState } from 'react';
import { THEME } from '../../../constants';
import { Loading } from '../../../components/loading';

const StyledHeader = styled.h1.attrs({
  className: 'StyledHeader',
})`
  text-align: center;
  padding-left: 0px;
  display: block;
  color: #fff;
  font-size: 35px;
  line-height: 40px;
  margin-top: 0px;
  margin-bottom: 20px;
  padding-top: 18px;
  padding-bottom: 18px;
  font-weight: 900;
`;

const StyledInput = styled.input.attrs({
  className: 'StyledInput',
})`
  border-radius: 8px;
  background-color: transparent;
  opacity: 0.8;
  font-family: 'Fontsfree net proxima nova';
  color: #fff;
  padding: 20.5px 12px;
  margin-bottom: 12px;
  font-size: 23px;
  line-height: 23px;
  font-weight: 300;
  cursor: text;
  width: 100%;
  border: 1px solid rgb(204, 204, 204);
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  &.h-70 {
    min-height: 70px;
  }
  &:focus,
  &:active,
  &:hover {
    border: 1px solid #fbb919;
    outline: none;
    opacity: 1;
  }
`;

const StyledButton = styled.button.attrs({
  className: 'StyledButton',
})<{ disabled }>(
  ({ disabled }) => `
    height: 70px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 8px;
    font-family: 'Fontsfree net proxima nova';
    font-size: 28px;
    font-weight: 600;
    border: none;
    color: rgb(255, 255, 255);
    margin-left: 0;
    width: 100%;
    background-color: ${disabled ? '#cccccc' : 'rgb(251, 185, 25)'};
    opacity: ${disabled ? 0.8 : 0.95};
    cursor: ${disabled ? 'default' : 'pointer'};
  `,
);

const TextContainer = styled.div.attrs({
  className: 'TextContainer',
})`
  margin-top: 15px;
  padding-right: 11px;
  padding-left: 11px;
  font-family: 'Fontsfree net proxima nova';
  font-weight: 300;
  color: hsla(0deg, 0%, 100%, 0.53);
  line-height: 22px;
`;

const YellowLink = styled.a.attrs({
  className: 'YellowLink',
})`
  color: ${THEME.yellow};
`;

export const SubmitEmail = () => {
  const [email, setEmail] = useState(null);
  const [success, setSuccess] = useState(false);
  const [{ data, loading }, submitResetPassword] = useAxios(
    {
      url: 'password_reset/',
      method: 'POST',
      data: {
        email,
      },
    },
    { manual: true },
  );

  const handleOnClick = () => {
    submitResetPassword().catch((error) => {
      setSuccess(true);
      return;
    });
  };

  useEffect(() => {
    setSuccess(Boolean(data));
  }, [data]);

  if (loading) return <Loading opacity={0.9} />;

  return (
    <>
      {success ? (
        <StyledHeader>
          We&apos;ve emailed you instructions for resetting your password. Please check your email!
        </StyledHeader>
      ) : (
        <>
          <StyledHeader>
            Enter your email address below, and we&apos;ll email instructions for resetting a new
            password.
          </StyledHeader>
          <StyledInput placeholder="Email" onChange={(event) => setEmail(event.target.value)} />
          <StyledButton onClick={handleOnClick} disabled={!email}>
            Request Password Change
          </StyledButton>
        </>
      )}
      <TextContainer>
        Our dedicated team is here to help. You can always shoot us an email at{' '}
        <YellowLink href="mailto:support@olehpay.co.il">support@olehpay.co.il</YellowLink>
      </TextContainer>
    </>
  );
};
